module.exports = __webpack_public_path__ + "img/DryfootFallows-800-450.753123b6.jpg";